<template>
  <div class="ef-user layout">

    <ef-header v-if="showHeader && !showFullScreen"/>

    <div class="mobile-msg d-block" v-if="mobileNotReady">
      <div class="mobile-img">
        <div class="tilt font-white-30">EliteFit.AI is coming to mobile soon!</div>
        <div class="works-best font-green-16">
          To see EliteFit.AI's magic, open it on your laptop
        </div>
      </div>
    </div>

    <ScrollMonitor @onBottom="onBottom">
      <div track-scroll :class="{ 'ef-container': (showHeader && !showFullScreen), 'w-100': (!showHeader || showFullScreen), 'h-100': (!showHeader || showFullScreen),  'vid-content' :  'vid-content'   }">
        <!-- <header-bar v-if="!showTiltMsg && showOldHeader"></header-bar> -->
          <div id="outer-container" class="content" v-if="!mobileNotReady"  style="overflow-x: hidden">
            <div style="height: 100%; width: 100%; min-height: calc(100vh - 3vh);">
              <router-view :key="$route.fullPath" ref="routerViewRef"></router-view>
            </div>
          </div>
      </div>

      <ef-footer v-if="showFooter && !showFullScreen"/>
    </ScrollMonitor>
  </div>
</template>

<script>
import AddVideo from "@/module_admin/views/AddVideo.vue";
import HeaderBar from "../../views/EFHeader.vue";
import EfHeader from "@/components/EfHeader";
import EfFooter from "@/components/EfFooter";
import {mapState} from "vuex";
import ScrollMonitor from "@/components/ScrollMonitor";

export default {
  data: function () {
    return {
      showTiltMsg: false,
      isOrientationLandscape: false,
      allowAllOrientations: false,
      enableAndroid: false,
      enableIOS: false,
      showOldHeaderOn: [
          'HoldRepWorkout',
          'RepWorkout',
          'workout',
          'workout Mobile'
      ],
      showFullScreenOn: [
        'CorporateDashboard',
        'User Progress',
        'Edit User Profile',
        'leaderboard',
        // 'Trainer Profile',
        'workoutIntro',
        'HoldRepWorkout',
        'RepWorkout',
        'workout'
      ],
    };
  },
  components: {
    EfFooter,
    EfHeader,
    HeaderBar,
    AddVideo,
    ScrollMonitor,
  },
  methods: {
    onBottom() {
      const onBottomFun = this.$refs.routerViewRef?.onBottom;
      if (typeof onBottomFun === 'function') onBottomFun();
    },
    showPopupNotification: function (payload) {
      this.$bvToast.toast(payload.message, {
        title: payload.type,
        variant: payload.type,
        headerClass: "toast__header",
        toaster: "b-toaster-bottom-center",
        solid: true,
        appendToast: true,
      });
    },
    downloadChrome() {
      window.open("https://www.google.com/intl/en_in/chrome/");
    },
    downloadFirefox() {
      window.open("https://www.mozilla.org/en-US/firefox/new/");
    },
    downloadSafari() {
      window.open("https://developer.apple.com/safari/technology-preview/");
    },
    handleOrientationChange() {
       const mql = window.matchMedia("(orientation: landscape)");
       this.isOrientationLandscape = mql.matches;
    }
  },
  computed: {
    ...mapState(["fullscreen"]),
    routeName() {
      return this.$route.name;
    },
    showHeader() {
      if(this.$route.name === 'EndWorkout Mobile' && !this.$store.state.userInfo?.isAnonymousUser){
        return false;
      }
      return !this.showOldHeaderOn.includes(this.$route.name);
    },
    showFooter() {
      if(this.$route.name === 'EndWorkout Mobile' && !this.$store.state.userInfo?.isAnonymousUser){
        return false;
      }
      return !this.showOldHeaderOn.includes(this.$route.name)
    },
    showFullScreen() {

      return ['workoutIntro', 'workout'].includes(this.$route.name) ||
      ((this.showFullScreenOn.includes(this.$route.name) || this.fullscreen) && !this.$store.state.userInfo?.isAnonymousUser);
    },
    showOldHeader() {
      return this.showOldHeaderOn.includes(this.$route.name);
    },
    mobileNotReady() {
      //Check Android
      if (this.isMobile && !(this.enableAndroid || this.enableMobileView)) {
        return true;
      }
      //Check IOS/Ipad
      if ((this.isIpad || this.isIOS) && !(this.enableIOS || this.enableMobileView)) {
        return true;
      }
      return false;
    },
    enableMobileView(){
      return sessionStorage.getItem("isMobileView")? true : false;
    },
    isMobile() {
      var isAndroid = /Android/i.test(navigator.userAgent);
      return isAndroid;
    },
    navigator() {
      return navigator.userAgent;
    },
    platform() {
      return navigator.platform;
    },
    isIOS() {
      var isiOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      return isiOS;
    },
    isIpad() {
      // Second condition is for IPad Pro
      return (/iPad/i.test(navigator.platform)
          || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document));
    },
    isAndroid() {
      return /Android/i.test(navigator.userAgent);
    },
    isFirefox() {
      return navigator.userAgent.indexOf("Firefox") > 0;
    },
    isSafari() {
      return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    },
    isSafariSupported() {
      return (
        this.isSafari &&
        parseFloat(
          navigator.userAgent.substring(
            navigator.userAgent.indexOf("Version/") + "Version/".length,
            navigator.userAgent.indexOf("Safari/") - 1
          )
        ) < 14.2
      );
    },
    isChrome() {return navigator.userAgent.indexOf("Chrome") > 0;},
    enableHomeHeader() {
      if (this.$route.name == 'Home') {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    let params = this.$route.query.isMobile? this.$route.query.isMobile : "false";
    if(params == "true"){
      sessionStorage.setItem("isMobileView", params);
    }
    this.enableAndroid = process.env.VUE_APP_ENABLE_ANDROID === 'true' ? true : false;
    this.enableIOS = process.env.VUE_APP_ENABLE_IOS === 'true' ? true : false;
    this.showTiltMsg = false;
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "user/notify") {
        this.showPopupNotification(mutation.payload);
      }
    });
    const mql = window.matchMedia("(orientation: landscape)");
    this.isOrientationLandscape = mql.matches;
    window.addEventListener("resize", this.handleOrientationChange, false);
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>
<style src="./../styles.scss" lang="scss">
@media only screen and (max-device-width: 600px) and (orientation: portrait){
  .mobile-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
  }
}
@media only screen and (max-device-width: 900px) and (orientation: landscape){
  .mobile-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
  }
}
</style>

